module.exports = __webpack_public_path__ + "img/mc_x.b3d02e85.png";